<template lang="html">
  <root class="admin-dishes-sort">

    <admin-nav></admin-nav>
    <page-header name="Re-order dishes"></page-header>

    <div class="container">

      <div class="row">
        <div class="col m6 offset-m3">
          <draggable class="collection" v-model="dishes">
            <li class="collection-item" v-for="dish of dishes">
              <div>
                {{ dish.name.en }}
                <a class="secondary-content">
                  <i class="material-icons">reorder</i>
                </a>
              </div>
            </li>
          </draggable>
        </div>
      </div>

      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" :disabled="isUpdating" @click="updateOrder()">Update</a>
        </div>
      </div>

    </div>
  </root>
</template>

<script>
import * as firebase from "firebase";
import draggable from "vuedraggable";
import _ from "lodash";

export default {
  components: {
    draggable,
  },

  data() {
    return {
      dishes: [],
      userKey: this.$route.params.userKey,
      businessKey: this.$route.params.businessKey,
      isUpdating: false,
    };
  },

  methods: {
    collect() {
      firebase
        .database()
        .ref("dishes")
        .orderByChild("business_key")
        .equalTo(this.businessKey)
        .once("value")
        .then((dishesSnap) => {
          if (!dishesSnap.exists()) return (this.dishes = []);

          dishesSnap.forEach((dishSnap) => {
            var dish = dishSnap.val();
            dish.key = dishSnap.key;
            this.dishes.push(dish);
          });

          this.dishes = _.orderBy(this.dishes, "position");
        });
    },

    updateOrder() {
      if (this.dishes.length) this.isUpdating = true;
      _.forEach(this.dishes, (dish, index) => {
        firebase
          .database()
          .ref("dishes/" + dish.key)
          .update({ position: index })
          .then((updatedPosition) => {
            var isEndPositioning = index == this.dishes.length - 1;
            if (isEndPositioning) {
              Materialize.toast("Updated", 4000);
              this.isUpdating = false;
            }
          });
      });
    },
  },

  mounted() {
    this.collect();
  },
};
</script>

<style lang="scss">
.admin-dishes-sort {
  .collection .collection-item {
    cursor: move;
    list-style: none;
    &:active {
      background: #f5f5f5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/DishesSort.vue